/* Build A Gym guest shortlist
   A browser-local commercial wish list. It deliberately stores only product facts
   rendered by Shopify, so the comparison never invents specifications. */
(function () {
  'use strict';

  var KEY = 'bagGuestShortlist.v2';
  var LEGACY_KEY = 'bagGuestShortlist.v1';
  var MAX_ITEMS = 20;
  var MAX_COMPARE = 3;
  var compareIds = [];
  var view = 'list';
  var statusMessage = '';
  var factHydration = {};

  function cleanTitle(value) {
    return String(value == null ? '' : value)
      .replace(/\s*\((?:new|remanufactured|used)\)\s*/gi, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function asBoolean(value) {
    return value === true || String(value).toLowerCase() === 'true';
  }

  function conditionLabel(value) {
    var condition = String(value || '').toLowerCase();
    if (condition === 'reman' || condition === 'remanufactured') return 'Remanufactured';
    if (condition === 'new') return 'New';
    if (condition === 'used') return 'Used';
    return '';
  }

  function warrantyLabel(row) {
    var condition = String(row.condition || '').toLowerCase();
    if (condition === 'used') return 'As-Is (No Warranty Coverage)';
    if (row.warranty) return row.warranty;
    if (condition === 'new' || condition === 'reman' || condition === 'remanufactured') {
      return '1 Year Parts & Labor (Extended Available)';
    }
    return 'Not listed';
  }

  function leadTimeLabel(row) {
    if (row.shipTime) return row.shipTime;
    var condition = String(row.condition || '').toLowerCase();
    if (condition === 'new') return '4–6 weeks';
    if (condition === 'reman' || condition === 'remanufactured') return '2–4 weeks';
    if (condition === 'used') return '1–2 weeks';
    return 'Not listed';
  }

  function productJsonUrl(row) {
    var link = document.createElement('a');
    link.href = String(row.url || '');
    if (!link.pathname || link.pathname.indexOf('/products/') !== 0) return '';
    return link.pathname.replace(/\/$/, '') + '.js';
  }

  function formatDescriptionDimensions(value) {
    var text = String(value || '').replace(/[“”″]/g, '"').replace(/\s+/g, ' ').trim();
    var match = text.match(/(?:[lL](?:ength)?\s*)?(\d+(?:\.\d+)?)\s*(?:in(?:ches)?\.?|\")?\s*(?:x|×)\s*(?:[wW](?:idth)?\s*)?(\d+(?:\.\d+)?)\s*(?:in(?:ches)?\.?|\")?(?:\s*(?:x|×)\s*(?:[hH](?:eight)?\s*)?(\d+(?:\.\d+)?)\s*(?:in(?:ches)?\.?|\")?)?/i);
    if (!match) return '';
    return match[1] + ' in L × ' + match[2] + ' in W' + (match[3] ? ' × ' + match[3] + ' in H' : '');
  }

  function descriptionDimensions(description) {
    if (!description || !window.DOMParser) return '';
    var doc = new DOMParser().parseFromString(description, 'text/html');
    var cards = doc.querySelectorAll('.bs-spec-card');
    for (var i = 0; i < cards.length; i++) {
      var label = cards[i].querySelector('.bs-spec-label');
      var value = cards[i].querySelector('.bs-spec-val');
      if (label && value && /dimensions?/i.test(label.textContent || '')) {
        var structured = formatDescriptionDimensions(value.textContent);
        if (structured) return structured;
      }
    }
    var plain = (doc.body && doc.body.textContent) || '';
    var labeled = plain.match(/(?:machine\s+)?dimensions?\b[^0-9]{0,40}([\s\S]{0,90})/i);
    return labeled ? formatDescriptionDimensions(labeled[1]) : '';
  }

  function hydrateMissingDimensions(rows) {
    rows.forEach(function (row) {
      if (row.dimensions || factHydration[row.id]) return;
      var endpoint = productJsonUrl(row);
      if (!endpoint) return;
      factHydration[row.id] = true;
      fetch(endpoint, { headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          var dimensions = descriptionDimensions(product && product.description);
          factHydration[row.id] = 'complete';
          if (!dimensions) { render(); return; }
          var current = read();
          var changed = false;
          current.forEach(function (candidate) {
            if (candidate.id === row.id && !candidate.dimensions) {
              candidate.dimensions = dimensions;
              changed = true;
            }
          });
          if (changed) write(current);
          render();
        })
        .catch(function () { factHydration[row.id] = 'complete'; render(); });
    });
  }

  function comparisonDimensions(row) {
    if (row.dimensions) return row.dimensions;
    if (!productJsonUrl(row) || factHydration[row.id] === 'complete') return 'Not listed';
    return 'Loading…';
  }

  function normalise(row) {
    if (!row) return null;
    return {
      id: String(row.id || ''),
      title: cleanTitle(row.title || ''),
      url: String(row.url || ''),
      image: String(row.image || ''),
      price: String(row.price || ''),
      condition: String(row.condition || '').trim(),
      variantId: String(row.variantId || ''),
      available: asBoolean(row.available),
      needsOptions: asBoolean(row.needsOptions),
      dimensions: String(row.dimensions || '').trim(),
      warranty: String(row.warranty || '').trim(),
      shipTime: String(row.shipTime || '').trim(),
      savedAt: Number(row.savedAt || Date.now())
    };
  }

  function read() {
    try {
      var stored = localStorage.getItem(KEY) || localStorage.getItem(LEGACY_KEY) || '[]';
      var rows = JSON.parse(stored);
      return Array.isArray(rows) ? rows.map(normalise).filter(function (row) {
        return row && row.id && row.title && row.url;
      }).slice(0, MAX_ITEMS) : [];
    } catch (e) { return []; }
  }

  function write(rows) {
    try { localStorage.setItem(KEY, JSON.stringify(rows.slice(0, MAX_ITEMS))); } catch (e) {}
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function productFrom(button) {
    return normalise({
      id: button.dataset.ctxSaveId,
      title: button.dataset.ctxSaveTitle,
      url: button.dataset.ctxSaveUrl,
      image: button.dataset.ctxSaveImage,
      price: button.dataset.ctxSavePrice,
      condition: button.dataset.ctxSaveCondition,
      variantId: button.dataset.ctxSaveVariantId,
      available: button.dataset.ctxSaveAvailable,
      needsOptions: button.dataset.ctxSaveNeedsOptions,
      dimensions: button.dataset.ctxSaveDimensions,
      warranty: button.dataset.ctxSaveWarranty,
      shipTime: button.dataset.ctxSaveShipTime,
      savedAt: Date.now()
    });
  }

  function isSaved(id) {
    return read().some(function (row) { return row.id === String(id); });
  }

  function setButtonState(button, saved) {
    if (!button) return;
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = button.querySelector('[data-ctx-save-label]');
    if (label) label.textContent = saved ? 'Saved' : 'Save for later';
    var icon = button.querySelector('[data-ctx-save-icon]');
    if (icon) icon.setAttribute('fill', saved ? 'currentColor' : 'none');
  }

  function syncButtons() {
    document.querySelectorAll('[data-ctx-save-product]').forEach(function (button) {
      setButtonState(button, isSaved(button.dataset.ctxSaveId));
    });
  }

  function selectedRows(rows) {
    return rows.filter(function (row) { return compareIds.indexOf(row.id) > -1; });
  }

  function cartActionLabel(row) {
    if (!row.variantId || row.needsOptions) return 'Choose options';
    return 'Add to cart';
  }

  function canAdd(row) {
    return !!row.variantId && !row.needsOptions;
  }

  function rowFacts(row) {
    return {
      'Price': row.price || 'Not listed',
      'Condition': conditionLabel(row.condition) || 'Not listed',
      'Overall dimensions': comparisonDimensions(row),
      'Warranty': warrantyLabel(row),
      'Lead time': leadTimeLabel(row)
    };
  }

  function renderList(rows) {
    return rows.map(function (row) {
      var image = row.image
        ? '<img src="' + escapeHtml(row.image) + '" alt="" loading="lazy" width="88" height="88">'
        : '<span class="ctx-shortlist__image-placeholder" aria-hidden="true"></span>';
      var selected = compareIds.indexOf(row.id) > -1;
      var cartAction = canAdd(row)
        ? '<button type="button" class="ctx-shortlist__add" data-ctx-shortlist-add="' + escapeHtml(row.id) + '">Add to cart</button>'
        : '<a class="ctx-shortlist__choose" href="' + escapeHtml(row.url) + '">' + escapeHtml(cartActionLabel(row)) + '</a>';
      return '<article class="ctx-shortlist__item">' +
        '<a class="ctx-shortlist__image" href="' + escapeHtml(row.url) + '">' + image + '</a>' +
        '<div class="ctx-shortlist__copy"><a href="' + escapeHtml(row.url) + '">' + escapeHtml(row.title) + '</a>' +
        '<span class="ctx-shortlist__price">' + escapeHtml(row.price || 'See product') + '</span>' +
        '<span class="ctx-shortlist__meta">' + escapeHtml(conditionLabel(row.condition) || 'Condition not listed') + (row.dimensions ? ' · ' + escapeHtml(row.dimensions) : '') + '</span></div>' +
        '<div class="ctx-shortlist__item-actions">' +
        cartAction +
        '<button type="button" class="ctx-shortlist__compare-select' + (selected ? ' is-selected' : '') + '" data-ctx-shortlist-compare-select="' + escapeHtml(row.id) + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' + (selected ? 'Selected' : 'Compare') + '</button>' +
        '<button type="button" class="ctx-shortlist__remove" data-ctx-shortlist-remove="' + escapeHtml(row.id) + '" aria-label="Remove ' + escapeHtml(row.title) + '">Remove</button></div>' +
      '</article>';
    }).join('');
  }

  function renderComparison(rows) {
    var facts = ['Price', 'Condition', 'Overall dimensions', 'Warranty', 'Lead time'];
    var header = '<thead><tr><th scope="col">Compare</th>' + rows.map(function (row) {
      var image = row.image
        ? '<img src="' + escapeHtml(row.image) + '" alt="" loading="lazy" width="160" height="160">'
        : '<span class="ctx-shortlist__compare-placeholder" aria-hidden="true"></span>';
      return '<th scope="col"><a href="' + escapeHtml(row.url) + '">' + image + '<span>' + escapeHtml(row.title) + '</span></a></th>';
    }).join('') + '</tr></thead>';
    var body = '<tbody>' + facts.map(function (label) {
      return '<tr><th scope="row">' + label + '</th>' + rows.map(function (row) {
        var value = rowFacts(row)[label];
        return '<td>' + escapeHtml(value) + '</td>';
      }).join('') + '</tr>';
    }).join('') + '</tbody>';
    return '<div class="ctx-shortlist__comparison-head"><div><strong>Compare saved equipment</strong><p>Only verified product facts are shown.</p></div><button type="button" class="ctx-shortlist__comparison-back" data-ctx-shortlist-compare-back>Back to list</button></div>' +
      '<div class="ctx-shortlist__comparison-wrap"><table class="ctx-shortlist__comparison-table">' + header + body + '</table></div>';
  }

  function setStatus(message) {
    statusMessage = message || '';
  }

  function render() {
    var rows = read();
    var addable = rows.filter(canAdd);
    hydrateMissingDimensions(rows);
    compareIds = compareIds.filter(function (id) { return rows.some(function (row) { return row.id === id; }); });
    if (view === 'compare' && compareIds.length < 2) view = 'list';

    document.querySelectorAll('[data-ctx-shortlist-count]').forEach(function (count) {
      count.textContent = rows.length;
      count.classList.toggle('is-empty', rows.length === 0);
    });

    document.querySelectorAll('[data-ctx-shortlist-items]').forEach(function (list) {
      if (!rows.length) {
        list.innerHTML = '<p class="ctx-shortlist__empty">Save machines while you browse. Your list stays in this browser without creating an account.</p>';
      } else if (view === 'compare') {
        list.innerHTML = renderComparison(selectedRows(rows));
      } else {
        list.innerHTML = renderList(rows);
      }
    });

    document.querySelectorAll('[data-ctx-shortlist-status]').forEach(function (status) {
      status.textContent = statusMessage || (rows.length ? rows.length + (rows.length === 1 ? ' item saved' : ' items saved') : '');
    });
    document.querySelectorAll('[data-ctx-shortlist-compare-open]').forEach(function (button) {
      var count = compareIds.length;
      button.classList.toggle('is-visible', count >= 2 && view !== 'compare');
      button.textContent = 'Compare ' + count + ' selected';
      button.disabled = count < 2;
    });
    document.querySelectorAll('[data-ctx-shortlist-add-all]').forEach(function (button) {
      button.hidden = !rows.length;
      button.disabled = !addable.length;
      button.textContent = addable.length ? 'Add ' + addable.length + ' to cart' : 'Add items to cart';
    });
    document.querySelectorAll('[data-ctx-shortlist-copy], [data-ctx-shortlist-clear]').forEach(function (button) {
      button.hidden = !rows.length;
    });

    syncButtons();
    document.dispatchEvent(new CustomEvent('ctx:shortlist:update', { detail: { count: rows.length } }));
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-ctx-shortlist-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ctx-shortlist-open');
    render();
    var close = drawer.querySelector('[data-ctx-shortlist-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-ctx-shortlist-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ctx-shortlist-open');
  }

  function toggle(button) {
    var product = productFrom(button);
    if (!product.id || !product.title || !product.url) return;
    var rows = read();
    var index = rows.findIndex(function (row) { return row.id === product.id; });
    if (index > -1) {
      rows.splice(index, 1);
      compareIds = compareIds.filter(function (id) { return id !== product.id; });
    } else {
      rows.unshift(product);
      if (rows.length > MAX_ITEMS) rows = rows.slice(0, MAX_ITEMS);
    }
    view = 'list';
    write(rows);
    render();
  }

  function toggleCompare(id) {
    var index = compareIds.indexOf(id);
    if (index > -1) compareIds.splice(index, 1);
    else if (compareIds.length < MAX_COMPARE) compareIds.push(id);
    render();
  }

  function cartRequest(path, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';
    return fetch(path, options);
  }

  function cartContainsRows(rows) {
    return cartRequest('/cart.js', { cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('cart-read-failed')); })
      .then(function (cart) {
        var lineIds = (cart.items || []).map(function (item) { return String(item.variant_id); });
        return rows.filter(function (row) { return lineIds.indexOf(String(row.variantId)) > -1; });
      });
  }

  function addSequentially(rows) {
    function addOne(row) {
      return cartRequest('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: String(row.variantId), quantity: 1 }] })
      }).then(function (response) { return response.ok; }).catch(function () { return false; });
    }
    function next(index) {
      if (index >= rows.length) return Promise.resolve();
      return addOne(rows[index]).then(function () { return next(index + 1); });
    }
    return next(0);
  }

  function addRows(rows, trigger) {
    var addable = rows.filter(canAdd);
    var needsOptions = rows.length - addable.length;
    if (!addable.length) {
      setStatus('Choose options on the product page before adding saved equipment to cart.');
      render();
      return;
    }
    var original = trigger ? trigger.textContent : '';
    if (trigger) { trigger.disabled = true; trigger.textContent = 'Adding…'; }

    /* Batch first to keep the cart mutation compact. If Shopify rejects one line,
       retry individually so currently available lines are not discarded. Neither
       path reports success until /cart.js confirms the requested variants exist. */
    cartRequest('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: addable.map(function (row) {
        return { id: String(row.variantId), quantity: 1 };
      }) })
    })
      .then(function (response) {
        return response.ok ? true : addSequentially(addable).then(function () { return false; });
      })
      .catch(function () { return addSequentially(addable).then(function () { return false; }); })
      .then(function () { return cartContainsRows(addable); })
      .then(function (confirmed) {
        var added = confirmed.length;
        if (added) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (added === addable.length && !needsOptions) {
          setStatus('Added ' + added + ' item' + (added === 1 ? '' : 's') + ' to cart.');
        } else if (added) {
          setStatus('Added ' + added + ' item' + (added === 1 ? '' : 's') + ' to cart. Open the remaining products to choose options or confirm availability.');
        } else {
          setStatus('We could not confirm these items in your cart. Open each product to choose options or confirm availability.');
        }
        render();
      })
      .catch(function () {
        setStatus('We could not confirm these items in your cart. Please try again or open each product to choose options.');
        render();
      })
      .finally(function () {
        if (trigger) { trigger.disabled = false; trigger.textContent = original; }
      });
  }

  function copySummary(rows, trigger) {
    var lines = ['CTX Home Gyms saved equipment', ''];
    rows.forEach(function (row, index) {
      lines.push((index + 1) + '. ' + row.title);
      lines.push('   Price: ' + (row.price || 'Not listed'));
      lines.push('   Condition: ' + (conditionLabel(row.condition) || 'Not listed'));
      var facts = rowFacts(row);
      lines.push('   Dimensions: ' + facts['Overall dimensions']);
      lines.push('   Warranty: ' + facts['Warranty']);
      lines.push('   Lead time: ' + facts['Lead time']);
      lines.push('   Link: ' + row.url);
      lines.push('');
    });
    var text = lines.join('\n');
    function complete() {
      setStatus('Saved-equipment summary copied.');
      render();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(complete).catch(function () { fallbackCopy(text, complete); });
    } else {
      fallbackCopy(text, complete);
    }
    if (trigger) trigger.blur();
  }

  function fallbackCopy(text, done) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(area);
    area.select();
    try { document.execCommand('copy'); } catch (e) {}
    area.remove();
    done();
  }

  document.addEventListener('click', function (event) {
    var save = event.target.closest('[data-ctx-save-product]');
    if (save) { event.preventDefault(); toggle(save); return; }

    var open = event.target.closest('[data-ctx-shortlist-open]');
    if (open) { event.preventDefault(); openDrawer(); return; }

    var backdrop = event.target.closest('[data-ctx-shortlist-backdrop]');
    if (backdrop) { event.preventDefault(); closeDrawer(); return; }

    var close = event.target.closest('[data-ctx-shortlist-close]');
    if (close) { event.preventDefault(); closeDrawer(); return; }

    var compareSelect = event.target.closest('[data-ctx-shortlist-compare-select]');
    if (compareSelect) { event.preventDefault(); toggleCompare(compareSelect.dataset.ctxShortlistCompareSelect); return; }

    var compareOpen = event.target.closest('[data-ctx-shortlist-compare-open]');
    if (compareOpen && compareIds.length >= 2) { event.preventDefault(); view = 'compare'; render(); return; }

    var compareBack = event.target.closest('[data-ctx-shortlist-compare-back]');
    if (compareBack) { event.preventDefault(); view = 'list'; render(); return; }

    var addOne = event.target.closest('[data-ctx-shortlist-add]');
    if (addOne) {
      event.preventDefault();
      var row = read().filter(function (candidate) { return candidate.id === addOne.dataset.ctxShortlistAdd; });
      addRows(row, addOne);
      return;
    }

    var addAll = event.target.closest('[data-ctx-shortlist-add-all]');
    if (addAll) { event.preventDefault(); addRows(read(), addAll); return; }

    var copy = event.target.closest('[data-ctx-shortlist-copy]');
    if (copy) { event.preventDefault(); copySummary(read(), copy); return; }

    var clear = event.target.closest('[data-ctx-shortlist-clear]');
    if (clear) {
      event.preventDefault();
      if (window.confirm('Clear all saved equipment? This does not change your cart.')) {
        compareIds = [];
        view = 'list';
        setStatus('Saved equipment cleared.');
        write([]);
        render();
      }
      return;
    }

    var remove = event.target.closest('[data-ctx-shortlist-remove]');
    if (remove) {
      event.preventDefault();
      var id = remove.dataset.ctxShortlistRemove;
      compareIds = compareIds.filter(function (compareId) { return compareId !== id; });
      write(read().filter(function (row) { return row.id !== id; }));
      render();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
}());
